/* eslint-disable camelcase */
/* eslint-disable max-lines */
import { useStorage, useValidation } from './helpers.js';

const { $, book: { makemodels } } = window;

function populateModelByMake(make) {
    if (make && makemodels && makemodels[make]) {
        const modelSelected = useStorage().get('model') || '-';
        const options = [];

        jQuery.each(makemodels[make].models, function(i, model) {
            options.push(new Option(
                model.model,
                i,
                i === modelSelected,
                i === modelSelected,
            ));
        });

        $('.custom-select-model')
            .empty()
            .append('<option></option>')
            .append(options)
            .trigger('change');
    }
}

$(document).ready(function() {
    $('select.custom-select').select2().on('change', function(e) {
        if ($(this).hasClass('custom-select-make')) {
            const make = $(this).val();

            populateModelByMake(make);
        }
    });

    if ($('.custom-select-model')[0]) {
        const make = useStorage().get('make_key');

        populateModelByMake(make);
    }

    const { isValidName, isValidPhone } = useValidation();

    $.validator.addMethod('isValidName', function(value) {
        return isValidName(value);
    });

    $.validator.addMethod('isValidPhone', function(value) {
        return isValidPhone(value, false);
    });

    $('#carInfoForm').validate({
        errorPlacement: function() {},
        ignore: '',
        invalidHandler: function(event, validator) {
            Object.keys(validator.errorMap).forEach(key => {
                $(`span.field-error[data-error="${key}"]`).text(validator.errorMap[key]).removeClass('hidden');
            });
        },
        messages: {
            make_key: 'Το πεδίο είναι υποχρεωτικό',
            model_key: 'Το πεδίο είναι υποχρεωτικό',
            'owner[fullname]': {
                isValidName: 'Παρακαλώ εισάγετε ένα έγκυρο Όνοματεπώνυμο / Επωνυμία',
                required: 'Το πεδίο είναι υποχρεωτικό',
            },
            'owner[phone]': {
                isValidPhone: 'Παρακαλώ εισάγετε έναν έγκυρο αριθμό τηλεφώνου',
                required: 'Το πεδίο είναι υποχρεωτικό',
            },
        },
        rules: {
            make_key: {
                maxlength: 64,
                required: true,
            },
            model_key: {
                maxlength: 64,
                required: true,
            },
            'owner[fullname]': {
                isValidName: true,
                required: true,
            },
            'owner[phone]': {
                isValidPhone: true,
                required: true,
            },
        },
        submitHandler: function() {
            window.location = '/step3';
        },
    });
});
